import { useBlockIntroStore } from '../../../../pinia/stores/blockIntro'

export const blockAlreadyVisited = (info) => useBlockIntroStore().blockAlreadyVisited(info)
export const visitedBlockStartTime = (info) => useBlockIntroStore().visitedBlockStartTime(info)
export const resetVisitedBlocks = () => useBlockIntroStore().resetVisitedBlocks()
